import { render, staticRenderFns } from "./fccGestaoArquivosParametros.vue?vue&type=template&id=4e27a25c"
import script from "./fccGestaoArquivosParametros.vue?vue&type=script&lang=js"
export * from "./fccGestaoArquivosParametros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports